import { render, staticRenderFns } from "./BulkDispatchBatch.vue?vue&type=template&id=693e2d62&"
import script from "./BulkDispatchBatch.vue?vue&type=script&lang=js&"
export * from "./BulkDispatchBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports